import { useEffect } from 'react'
import { useRouteError, isRouteErrorResponse, Link } from 'react-router'
import { useTranslation } from 'react-i18next'
import { Loader2 } from 'lucide-react'
import { Button } from '@/components/ui/button'

function isChunkLoadError(error: unknown): boolean {
  return (
    error instanceof TypeError &&
    (error.message.includes('dynamically imported module') ||
      error.message.includes('Failed to fetch'))
  )
}

export function RouteErrorPage() {
  const { t } = useTranslation('common')
  const error = useRouteError()
  const is404 = isRouteErrorResponse(error) && error.status === 404
  const isChunkError = isChunkLoadError(error)

  useEffect(() => {
    if (!isChunkError) return
    if (sessionStorage.getItem('chunkReload') === '1') {
      sessionStorage.removeItem('chunkReload')
      return
    }
    sessionStorage.setItem('chunkReload', '1')
    window.location.reload()
  }, [isChunkError])

  if (isChunkError) {
    return (
      <div className="flex min-h-screen flex-col items-center justify-center p-8 text-center">
        <Loader2 className="mb-6 size-10 animate-spin text-primary" />
        <h2 className="mb-2 text-2xl font-bold">{t('errors.updating')}</h2>
        <p className="max-w-md text-muted-foreground">{t('errors.updatingDesc')}</p>
      </div>
    )
  }

  return (
    <div className="flex min-h-screen flex-col items-center justify-center p-8 text-center">
      <div className="mb-4 text-6xl">⚠️</div>
      <h2 className="mb-2 text-2xl font-bold">
        {is404 ? t('errors.notFound') : t('errors.generic')}
      </h2>
      <p className="mb-6 max-w-md text-muted-foreground">
        {is404 ? t('errors.notFound') : t('errors.serverError')}
      </p>
      <div className="flex gap-4">
        <Button variant="outline" asChild>
          <Link to="/">{t('back')}</Link>
        </Button>
        <Button onClick={() => window.location.reload()}>{t('tryAgain')}</Button>
      </div>
    </div>
  )
}
